module.exports = __webpack_public_path__ + "static/img/c7.a889a2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c7.png
// module id = 2oZE
// module chunks = 1